import type { QueryObject, QueryValue } from '../api/httpClient';
import { buildQueryString } from '../api/httpClient';

export function buildUrlWithParams(
  baseUrl: string,
  params?: QueryObject,
  defaults?: Partial<QueryObject>
): string {
  if (!baseUrl) {
    return '';
  }
  
  const mergedParams: QueryObject = { ...defaults };
  
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        mergedParams[key] = value;
      }
    });
  }
  
  const queryString = buildQueryString(mergedParams);
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

export function buildOrderedUrlWithParams<T extends Record<string, QueryValue>>(
  baseUrl: string,
  params: T,
  paramOrder: (keyof T)[],
  defaults?: Partial<T>
): string {
  if (!baseUrl) {
    return '';
  }
  
  const mergedParams: Record<string, QueryValue> = { ...defaults };
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      mergedParams[key] = value;
    }
  });
  
  const queryParts: string[] = [];
  
  for (const key of paramOrder) {
    const keyStr = String(key);
    const value = mergedParams[keyStr];
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach(item => {
          queryParts.push(`${keyStr}=${encodeURIComponent(String(item))}`);
        });
      } else {
        queryParts.push(`${keyStr}=${encodeURIComponent(String(value))}`);
      }
      delete mergedParams[keyStr];
    }
  }
  
  Object.entries(mergedParams).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach(item => {
          queryParts.push(`${key}=${encodeURIComponent(String(item))}`);
        });
      } else {
        queryParts.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    }
  });
  
  return queryParts.length > 0 ? `${baseUrl}?${queryParts.join('&')}` : baseUrl;
}
